'use client';

import Link from 'next/link';
import { ComponentPropsWithoutRef, useContext } from 'react';
import { Media } from '@/shared/ui/media';
import { Media as MediaType } from '@/shared/ui/media/types';
import './mini-banner.scss';
import { MiniBannersContext } from './mini-banners-context';

type Props = {
    data: MediaType;
    index: number;
} & ComponentPropsWithoutRef<typeof Media>;
export const MiniBanner = ({ data, index, ...props }: Props) => {
    const { useStore, variant } = useContext(MiniBannersContext);
    const isInView = useStore((s) => (variant === 'grid' ? true : s.slidesInView.includes(index)));

    const MediaComponent = (
        <Media
            data={data}
            height={512}
            width={0}
            className="mini-banners__media"
            priority
            isInView={isInView}
            {...props}
        />
    );

    if (data.link) {
        return (
            <Link
                href={data.link.url}
                target={data.link.isOpenInNewTab ? '_blank' : undefined}
                className="mini-banners__media_wrapper"
            >
                {MediaComponent}
            </Link>
        );
    }

    return <div className="mini-banners__media_wrapper">{MediaComponent}</div>;
};
